export default __webpack_public_path__ + "img/email.1ac22dbf.svg";